module.exports = __webpack_public_path__ + "img/32@2x.d7d4502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/32@2x.png
// module id = B8hP
// module chunks = 0